import React from 'react';
import ExpandableContainer from '../ExpandableContainer';
import * as Row from '../../../layout/Row';

export default class SummaryOptionsSection extends React.Component {
    render() {


        if (this.props.model.unitType.isCustomLogic.value)
            return (<React.Fragment></React.Fragment>)

        const hasHeating1 = (typeof this.props.model.heating1 !== 'undefined')
        const hasHeating2 = (typeof this.props.model.heating2 !== 'undefined')
        const hasHeating3 = (typeof this.props.model.heating3 !== 'undefined')
        const hasDHW = (typeof this.props.model.dhw !== 'undefined')

        const isAnyPumpAddOnAvailable = () => {
            let result = false

            if (hasHeating1) result = result || this.props.model.heating1.pumpAddOn.value
            if (hasHeating2) result = result || this.props.model.heating2.pumpAddOn.value
            if (hasHeating3) result = result || this.props.model.heating3.pumpAddOn.value
            if (hasDHW) result = result || this.props.model.dhw.pumpAddOn.value

            return result
        }

        return (
            <ExpandableContainer label={__('Options and accessories')}>
                <Row.Container hasOuterGutter={false}>
                    <Row.Column6>
                        {this.props.model.optionsAndAccessories.commisioning.value && (
                            <div className="configuration-editor-summary-heating-field">
                                <div>{this.props.model.optionsAndAccessories.commisioning.label}</div>
                                <div>{this.getFieldValue(this.props.model.optionsAndAccessories.commisioning)}</div>
                            </div>
                        )}

                        {this.props.model.optionsAndAccessories.iqHeatCloud.value && (
                            <div className="configuration-editor-summary-heating-field">
                                <div>{this.props.model.optionsAndAccessories.iqHeatCloud.label}</div>
                                <div>{this.getFieldValue(this.props.model.optionsAndAccessories.iqHeatCloud)}</div>
                            </div>
                        )}

                        {this.props.model.optionsAndAccessories.pipeInsulation.value && (
                            <div className="configuration-editor-summary-heating-field">
                                <div>{this.props.model.optionsAndAccessories.pipeInsulation.label}</div>
                                <div>{this.getFieldValue(this.props.model.optionsAndAccessories.pipeInsulation)}</div>
                            </div>
                        )}

                        {isAnyPumpAddOnAvailable() && (
                            <div className="configuration-editor-summary-opts-pumpaddon">
                                <div>
                                    <Row.Container hasOuterGutter={false}>
                                        <Row.Column6>
                                            <div className="configuration-editor-summary-ut-section">
                                                <div>{__('Pump add on')}</div>
                                                <div>
                                                    <table className="configuration-editor-summary-table">
                                                        <thead>
                                                        <tr>
                                                            {hasHeating1 && (
                                                                <th>{this.props.model.heating1.name.value}</th>)}
                                                            {hasHeating2 && (
                                                                <th>{this.props.model.heating2.name.value}</th>)}
                                                            {hasHeating3 && (
                                                                <th>{this.props.model.heating3.name.value}</th>)}
                                                            {hasDHW && (<th>{this.props.model.dhw.name.value}</th>)}
                                                        </tr>
                                                        </thead>

                                                        <tbody>
                                                        <tr>
                                                            {hasHeating1 && (
                                                                <td>{this.getFieldValue(this.props.model.heating1.pumpAddOn)}</td>)}
                                                            {hasHeating2 && (
                                                                <td>{this.getFieldValue(this.props.model.heating2.pumpAddOn)}</td>)}
                                                            {hasHeating3 && (
                                                                <td>{this.getFieldValue(this.props.model.heating3.pumpAddOn)}</td>)}
                                                            {hasDHW && (
                                                                <td>{this.getFieldValue(this.props.model.dhw.pumpAddOn)}</td>)}
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </Row.Column6>
                                    </Row.Container>
                                </div>
                            </div>
                        )}
                    </Row.Column6>
                </Row.Container>
            </ExpandableContainer>
        )
    }


    getFieldValue(field) {
        if (field.items) {
            let val = field.items.find(x => x.value === field.value)
            if (typeof val === 'object') {
                return val.text
            }
        }

        return field.value
    }
}